import React from "react"
import { auditShape } from "utils/propTypeShapes"

const AttachmentCreatedAuditItemDetails = ({ audit }) => {
  const { attachmentName } = audit

  return (
    <div>
      Attached { attachmentName ? ` the file ${attachmentName}` : " a file"}.
    </div>
  )
}

AttachmentCreatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default AttachmentCreatedAuditItemDetails
